export interface PrintReserveForwardingRequestRequest {
  ids: number[]
}

export function PrintReserveForwardingRequestRequestToJSON(
  value: PrintReserveForwardingRequestRequest
): any {
  return {
    ids: value.ids.length > 0 ? value.ids : undefined
  }
}
